import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const EstoniaFlagIcon: FC<IconProps> = ({ width = 21, height = 15, ...rest }) => (
  <Icon type="EstoniaFlagIcon" width={width} height={height} alt="EstoniaFlagIcon" {...rest} />
)
